// extracted by mini-css-extract-plugin
export default {"spinner_wrapper":"waitPaidInvoice_spinner_wrapper__eu1wG"};